export class ManagementOperationsUnregisteredExecutorDeleteRequest {
  unregisteredExecutorId!: string

  constructor(unregisteredExecutorId: string) {
    this.unregisteredExecutorId = unregisteredExecutorId
  }
}
